import React from 'react';

import useCurrentLang from '@/hooks/apps/useCurrentLang';

import {
  HOME_HERO_COPY_BY_LOCALE,
  resolveHomeHeroHeadline,
} from '@/data/shared/homeHeroCopy';

import Area from '@/components/apps/layouts/shared/Area';

import ProductionRailIllustration from './productionRail/ProductionRailIllustration';

/**
 * ### ClaimEvidenceSection
 *
 * The production line at work, then the press-kit claim about it with its
 * one-sentence subcopy. The figures that back the claim follow in the proof
 * section, which scrolls through them one at a time. Which headline appears
 * is decided by the copy module, so swapping candidates never touches this
 * component.
 *
 * @returns The rendered claim section element
 * @see {@link HOME_HERO_COPY_BY_LOCALE} The copy rendered here
 */
export default function ClaimEvidenceSection() {
  const currentLang = useCurrentLang();
  const { subcopy } = HOME_HERO_COPY_BY_LOCALE[currentLang];

  return (
    <section
      className="bg-apps-brandGrayBlack"
      data-analytics-section="home_claim_evidence"
    >
      {/* Full-bleed on purpose: the line runs from one screen edge to the other */}
      <div className="pt-[72px] lg:pt-[clamp(100px,9vw,140px)]">
        <ProductionRailIllustration />
      </div>
      <Area>
        <div className="pb-[48px] pt-12 text-center lg:pb-[64px] lg:pt-20">
          <h2 className="mx-auto max-w-[1100px] text-balance text-[36px] font-bold leading-[128%] tracking-[-0.72px] text-apps-coreGrayWhite sm:text-[44px] lg:text-[clamp(56px,5vw,80px)] lg:leading-[120%] lg:tracking-[-1.6px]">
            {resolveHomeHeroHeadline(currentLang)}
          </h2>
          <p className="mx-auto mt-5 max-w-[760px] text-pretty text-[15px] font-medium leading-[160%] tracking-[-0.3px] text-apps-brandGray700 lg:mt-8 lg:text-[clamp(17px,1.389vw,20px)] lg:leading-[170%]">
            {subcopy}
          </p>
        </div>
      </Area>
    </section>
  );
}
